import * as React from "react";
import * as R from "ramda";
import {connect} from "react-redux";
import {ButtonToolbar, DropdownButton, Glyphicon} from "react-bootstrap";
import {List} from "material-ui/List";
import {MenuItem, SubItem} from "./MenuItem";
import HomeIcon from "material-ui/svg-icons/action/home";
import ViewIcon from "material-ui/svg-icons/navigation/arrow-forward";
import {abrirMenu, cerrarMenu} from "../modulos/inicioActions";

class Menu extends React.Component<any, any> {

    toggleMenu = (menuOpened: boolean) => {
        if (menuOpened) {
            this.props.dispatch(cerrarMenu());
        } else {
            this.props.dispatch(abrirMenu());
        }
    };


    render() {
        const {menuArray, menuOpened} = this.props;
        return (
            <div>
                <ButtonToolbar>
                    <DropdownButton
                        bsStyle={null}
                        className="btns btns-primary"
                        title={<Glyphicon className={"menu-hamburger"} glyph={"menu-hamburger"}/>}
                        noCaret
                        onToggle={() => this.toggleMenu(menuOpened)}
                        open={menuOpened}
                        id="dropdown-no-caret"
                    >
                        <div className={"sidebar"}>
                            <List>
                                <MenuItem onClick={() => this.toggleMenu(true)} className={"dividerb menu-item"}
                                          key={"home"} title={"Inicio"} url="/" icon={<HomeIcon/>}/>
                                {menuArray.map(menu => {
                                        return menu.menuItems.map(item =>
                                            <MenuItem className={"dividerb menu-item"}
                                                      key={item.cdresource} title={item.name}
                                                      url={item.contextPath}
                                                      onClick={() => this.toggleMenu(true)}
                                                      icon={item.image ? item.image : <ViewIcon/>}
                                                      subItems={this.obtenerSubItems(item.children)}/>
                                        );
                                    }
                                )}
                            </List>
                        </div>
                    </DropdownButton>
                </ButtonToolbar>
            </div>
        );
    }

    obtenerSubItems = (menuChildren: Array<any>): Array<SubItem> => {
        return menuChildren ? menuChildren.map(item => {
                return {name: item.name, url: item.contextPath, key: item.cdresource};
            }
        ) : [];
    }
}

export default connect((store: any) => {
    return {
        menuArray: R.pathOr([], ["inicio", "menu"])(store),
        menuOpened: R.pathOr([], ["inicio", "menuOpened"])(store)
    };
})(Menu);


// WEBPACK FOOTER //
// ./src/co/sura/inicio/componentes/Menu.tsx